import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SmartAccess.css";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SMRTAccessSitewiz() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("id");
  const mode = searchParams.get("mode");
  const isView = mode === "view";

  const [step, setStep] = useState(isView ? 3 : 1);
  const [sites, setSites] = useState<any[]>([]);

  const [form, setForm] = useState({
    name: "",
    displayName: "",
    ip: "",
    port: "",
    ipPassword: "",
    panelPassword: "",
  });

  useEffect(() => {
    fetch(`${API}/smrtaccess/sites`, { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        const loaded = data.sites || [];
        setSites(loaded);
        if (editId) {
          const site = loaded.find((s: any) => s.id.toString() === editId);
          if (site) {
            setForm({
              name: site.name || "",
              displayName: site.displayName || "",
              ip: site.ip || "",
              port: site.port || "",
              ipPassword: site.ipPassword || "",
              panelPassword: site.panelPassword || "",
            });
          }
        }
      })
      .catch(err => console.error("Failed to load sites:", err));
  }, [editId]);

  const updateField = (field: string, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="smrt-access-container">
      <div
        className="smrt-access-panel"
        style={{ maxWidth: "600px", margin: "0 auto" }}
      >
        <div className="panel-header">
          <h3>{editId ? "Edit Site" : "Add Site"}</h3>
        </div>

        <div className="panel-body">
          {/* STEP 1 */}
          {step === 1 && (
            <>
              <label>Site ID (Internal Name)</label>
              <input
                className="door-input"
                value={form.name}
                onChange={(e) => updateField("name", e.target.value)}
              />

              <label>Display Name (Short)</label>
              <input
                className="door-input"
                value={form.displayName}
                onChange={(e) => updateField("displayName", e.target.value)}
                placeholder="e.g. BBM"
              />

              <div className="wizard-actions">
                <button
                  className="btn-cancel"
                  onClick={() => navigate("/smrt-access")}
                >
                  Cancel
                </button>

                <button className="btn-success" onClick={() => setStep(2)}>
                  Next
                </button>
              </div>
            </>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <>
              <label>Panel IP</label>
              <input
                className="door-input"
                value={form.ip}
                onChange={(e) => updateField("ip", e.target.value)}
              />

              <label>Port</label>
              <input
                className="door-input"
                value={form.port}
                onChange={(e) => updateField("port", e.target.value)}
              />

              <label>IP Module Password</label>
              <input
                type="password"
                className="door-input"
                value={form.ipPassword}
                onChange={(e) => updateField("ipPassword", e.target.value)}
              />

              <label>Panel Password</label>
              <input
                type="password"
                className="door-input"
                value={form.panelPassword}
                onChange={(e) => updateField("panelPassword", e.target.value)}
              />

              <div
                style={{ marginTop: "1rem", display: "flex", gap: "0.5rem" }}
              >
                <button className="btn-cancel" onClick={() => setStep(1)}>
                  Back
                </button>

                <button className="btn-success" onClick={() => setStep(3)}>
                  Next
                </button>
              </div>
            </>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <>
              <h4>{isView ? "View Site" : "Confirm"}</h4>

              <div>Name: {form.name}</div>
              <div>Display: {form.displayName || "—"}</div>
              <div>IP: {form.ip}</div>
              <div>Port: {form.port}</div>
              <div>IP Password: {form.ipPassword || "—"}</div>
              <div>Panel Password: {form.panelPassword || "—"}</div>

              <div
                style={{ marginTop: "1rem", display: "flex", gap: "0.5rem" }}
              >
                <button
                  className="btn-cancel"
                  onClick={() =>
                    isView ? navigate("/smrt-access") : setStep(2)
                  }
                >
                  Back
                </button>

                {!isView && (
                  <button
                    className="btn-success"
                    onClick={async () => {
                      let updated;

                      if (editId) {
                        updated = sites.map((s: any) =>
                          s.id.toString() === editId
                            ? {
                                ...s,
                                name: form.name,
                                displayName: form.displayName,
                                ip: form.ip,
                                port: form.port,
                                ipPassword: form.ipPassword || s.ipPassword,
                                panelPassword:
                                  form.panelPassword || s.panelPassword,
                              }
                            : s,
                        );
                      } else {
                        const newSite = {
                          id: Date.now(),
                          name: form.name,
                          displayName: form.displayName,
                          ip: form.ip,
                          port: form.port,
                          ipPassword: form.ipPassword,
                          panelPassword: form.panelPassword,
                        };

                        updated = [...sites, newSite];
                      }

                      try {
                        await fetch(`${API}/smrtaccess/sites`, {
                          method: "PUT", credentials: "include",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ sites: updated }),
                        });
                      } catch (err) {
                        console.error("Failed to save sites:", err);
                      }

                      navigate("/smrt-access");
                    }}
                  >
                    Save
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
